module.exports = __webpack_public_path__ + "img/tempo.ac021c89.svg";